/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-computed-properties-in-native-classes, ember/no-controller-access-in-routes, ember/no-get, warp-drive/no-legacy-request-patterns */
import { get } from '@ember/object';
import Route from '@ember/routing/route';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import Jurisdiction from '@linc-technologies/linced-common/enums/jurisdiction';
import { hash } from '@linc-technologies/linced-common/utils/promise';

const DEFAULT_DETAIL_OPTIONS = [
  {
    responseActivityGroup: 1,
    details: [
      'Sent notification to whānau',
      'Sent escalated notification to whānau',
      'Sent formal warning notice to whānau',
      'Sent letter acknowledging upcoming absence',
    ],
  },
  {
    responseActivityGroup: 2,
    details: [
      'Initial conversation with whānau',
      'Escalated conversation with whānau',
      'Held whānau hui',
    ],
  },
  {
    responseActivityGroup: 3,
    details: [], // Developed individual support plan – free text only
  },
  {
    responseActivityGroup: 4,
    details: [
      'Reduced transport barriers',
      'Reduced food barriers',
      'Reduced clothing barriers',
      'Reduced equipment barriers',
      'Referred to in-school social worker',
      'Referred to in-school counsellor',
      'Referred to in-school mentor',
      'Reduced other barriers',
    ],
  },
  {
    responseActivityGroup: 5,
    details: [
      'Reinforcement conversation',
      'Reinforcement letter/certificate',
      'Other positive action',
    ],
  },
  {
    responseActivityGroup: 6,
    details: [
      'Referred to attendance services',
      'Referred to local provider',
      'Referred to iwi provider',
      'Referred to alternative education/activity centre',
      'Referred to Ministry regional office',
      'Referred to external mental health support',
      'Referred to other education agency',
      'Referred to other non-education agency',
    ],
  },
  {
    responseActivityGroup: 7,
    details: [],
  },
  {
    responseActivityGroup: 8,
    details: [],
  },
  {
    responseActivityGroup: 9,
    details: [],
  },
  {
    responseActivityGroup: 99,
    details: [],
  },
];

export default class GroupRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  // Attrs
  @alias('session.school.jurisdiction')
  jurisdiction;

  model(params) {
    let schoolId = this.session.activeSchool;
    let headings = this.store
      .peekAll('school-options/heading')
      .filter((heading) => get(heading, 'groupId.id') === params.optiongroup_id)
      .filter((heading) => heading.name !== 'Board Elections');
    let headingIds = headings.map((heading) => heading.id);
    let responseActivityConfig = null;
    if (this.jurisdiction === Jurisdiction.NZ_MOE) {
      responseActivityConfig = this.store.query(
        'attendance/response-activity-configuration',
        { schoolId },
      );
    }
    return hash({
      // Reload the school record to pull any external changes.
      school: this.store.findRecord(
        'school',
        this.get('session.activeSchool'),
        { reload: true },
      ),
      group: this.store.peekRecord(
        'school-options/group',
        params.optiongroup_id,
      ),
      headings,
      options: this.store.peekAll('school-options/field').filter((option) => {
        return headingIds.includes(option.get('headingId.id'));
      }),
      responseActivityConfig,
    });
  }

  afterModel(model) {
    super.afterModel(...arguments);
    this.controllerFor('application').set(
      'currentOptionGroupId',
      model.group.id,
    );
  }

  // configure detail options
  setupController(controller, model) {
    super.setupController(...arguments);
    if (this.jurisdiction !== Jurisdiction.NZ_MOE) {
      return;
    }

    let config = model.responseActivityConfig;
    let options = DEFAULT_DETAIL_OPTIONS;

    if (config.length) {
      options = config[0].configuration;
    }

    controller.set('detailOptions', options);
  }

  deactivate() {
    super.deactivate(...arguments);
    this.controllerFor('application').set('currentOptionGroupId', null);
  }
}
